




























































import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class ProjectRequestsComponet extends Vue {
  actualPage = 1;
  application = this.$store.state.application;
  lookup = this.$store.state.lookup;
  editedItem = {};
  dialog = false;

  get project(): [] {
    return this.$store.state.project.detail;
  }

  get headers() {
    return [
      { text: this.$t('project.state.request.edit'), value: 'edit', sortable: false, align: 'center', width: '10%' },
      { text: this.$t('project.state.request.requestState'), value: 'requestState', sortable: false, width: '10%' },
      { text: this.$t('project.state.request.state'), value: 'stateTemplate', sortable: false, width: '10%' },
      { text: this.$t('project.state.request.note'), value: 'note', sortable: false, width: '35%' },
      { text: this.$t('project.state.request.resultNote'), value: 'resultNote', sortable: false, width: '35%' }
    ];
  }

  handleStateChangeRequest(request: any, approved: boolean) {
    const id = this.$route.params.id;
    const stateRequest = request;
    stateRequest.approved = approved;

    this.$store.dispatch('project/resolveStateChangeRequest', { id, stateRequest });
    this.dialog = false;
  }

  onPage(page: number): void {
    this.actualPage = page;
  }

  editItem(item: any) {
    this.editedItem = Object.assign({}, item);
    this.dialog = true;
  }

  getLookupItemName(code: string) {
    const lookup = this.$store.getters['lookup/getAvailableLookupDetail'](1);
    return lookup.find((item: any) => item.key === code)?.value;
  }

  getRequestState(request: any) {
    if (request.approved === undefined) {
      return 'Ke schválení';
    }
    if (!request.approved) {
      return 'Neschváleno';
    }
    if (request.approved) {
      return 'Schváleno';
    }
  }
}
